var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowDetailsInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1.2,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KA---04-Copy",
    transform: "translate(-256.000000, -464.000000)",
    fill: "#839DC7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/16px/Info/View-Summary/Inactive",
    transform: "translate(256.000000, 464.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,0 L10.7107864,0 C10.9760029,0 11.2303568,0.10535684 11.4178932,0.292893219 L15.7071068,4.58210678 C15.8946432,4.76964316 16,5.02399707 16,5.28921356 L16,15 C16,15.5522847 15.5522847,16 15,16 L1,16 C0.44771525,16 5.10702591e-14,15.5522847 5.10702591e-14,15 L5.10702591e-14,1 C5.10702591e-14,0.44771525 0.44771525,0 1,0 Z M1.7,1.7 L1.7,14.3 L14.3,14.3 L14.3,5.57916306 L10.4208369,1.7 L1.7,1.7 Z M4.53044755,12.9869811 C4.18033651,13.3370921 3.61269434,13.3370921 3.26258329,12.9869811 C2.91247224,12.63687 2.91247224,12.0692279 3.26258329,11.7191168 L6.18855946,8.79314064 L3.98865391,8.79303084 C3.49352211,8.79300613 3.09215852,8.39160247 3.09218323,7.89647067 C3.09220795,7.40133888 3.49361161,7 3.9887434,7 L8.35331153,7.00021784 C8.84840838,7.00024255 9.24975749,7.40159167 9.2497822,7.89668851 L9.25,12.2603853 C9.25,12.7555171 8.84866112,13.1569208 8.35352933,13.1569455 C7.85839753,13.1569702 7.45699387,12.7556066 7.45696916,12.2604748 L7.45685936,10.0605693 L4.53044755,12.9869811 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowDetailsInactive);
export default __webpack_public_path__ + "static/media/show-details-inactive.3dca296bffc202e71438ed20be11e6cc.svg";
export { ForwardRef as ReactComponent };